import { saleRepository } from '../../infrastructure/repositories/SaleRepository';
import type {
  SaleListResponse,
  SaleWithDetails,
  SaleFilters,
  SalesSummary
} from '../../domain/entities/Sale';

export class SaleService {
  async getSales(filters: SaleFilters = {}): Promise<SaleListResponse> {
    return await saleRepository.getSales(filters);
  }

  async getSaleById(id: string): Promise<SaleWithDetails> {
    return await saleRepository.getSaleById(id);
  }

  async getSalesSummary(dateFrom?: string, dateTo?: string): Promise<SalesSummary> {
    return await saleRepository.getSalesSummary(dateFrom, dateTo);
  }
}

export const saleService = new SaleService();

